import BaseComponent from 'scripts/BaseComponent.js';

export default class Sort extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      sortToggleBtn: '.js-sortToggleBtn',
      sortOptionBtn: '.js-sortOptionBtn',
    };

    this.dom = {
      $component: component,
      $sortToggleBtn: this.$get(this.refs.sortToggleBtn),
      $sortOptionBtns: this.$getAll(this.refs.sortOptionBtn),
    };

    this.state = {
      sortOpen: false,
      sortOpenClass: 'open-sort-options',
      updateSortEvent: 'updatesort',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setClick(dom.$sortToggleBtn, this.toggleSort);
    this.setClickWithElement(dom.$sortOptionBtns, this.updateSort);
  }

  toggleSort() {
    const { state } = this;

    if (state.sortOpen) {
      this.closeSort();
    } else {
      this.openSort();
    }
  }

  openSort() {
    const { dom, state } = this;

    dom.$component.classList.add(state.sortOpenClass);
    document.addEventListener('click', this.clickOutHandler.bind(this));
    state.sortOpen = true;
  }

  closeSort() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.sortOpenClass);
    document.removeEventListener('click', this.clickOutHandler.bind(this));
    state.sortOpen = false;
  }

  clickOutHandler(e) {
    const { dom } = this;

    if (!dom.$component.contains(e.target)) {
      this.closeSort();
    }
  }

  updateSort(button) {
    const { state: { updateSortEvent } } = this;
    const { value } = button.dataset;
    this.dispatch(updateSortEvent, { value });
  }
}
